import React from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { styled } from "@mui/material/styles";
import {
  BORDER_PRIMARY,
  OVERFLOW_HIDDEN,
  TEXT_ALIGN_LEFT,
} from "../config/styles";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    border: BORDER_PRIMARY,
    overflow: OVERFLOW_HIDDEN,
    borderRadius: 4,
    backgroundColor: "transparent",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      borderColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-input": {
      ...theme.typography.subtitle2,
      textAlign: TEXT_ALIGN_LEFT,
    },
  },
}));

export const SearchInput = ({
  value = "",
  onChange = null,
  placeholder = "Search",
  style = {},
  onClickSearch = null,
  iconPosition = "end",
}) => {
  return (
    <StyledTextField
      variant="outlined"
      fullWidth
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      style={style}
      InputProps={
        iconPosition === "start"
          ? {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlinedIcon onClick={onClickSearch} />
                </InputAdornment>
              ),
            }
          : {
              endAdornment: (
                <InputAdornment position="end">
                  <SearchOutlinedIcon onClick={onClickSearch} />
                </InputAdornment>
              ),
            }
      }
    />
  );
};

SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  onClickSearch: PropTypes.func,
  iconPosition: PropTypes.oneOf(["start", "end"]),
};
